import { Component, HostListener, OnInit } from '@angular/core';
import moment from 'moment';

import { AssignmentService } from '../shared/assignment.service';
import { CommonService } from '../shared/common.service';
import { FilterService } from '../shared/filter.service';
import { InfoMessageService } from '../shared/infomessage.service';
import { UserService } from '../shared/user.service';
import { UserInfoService } from '../shared/userinfo.service';

import { AssignmentData } from '../model/assignmentdata';
import { ChangeAssignmentDate } from '../model/changeassignmentdate';
import { Consultant } from '../model/consultant';
import { InfoMessageItem } from '../model/infomessage';
import { ReturnObject } from '../model/returnobject';
import { User } from '../model/user';

import { ConsultantService } from '../shared/consultant.service';
import { InternalMsgService } from '../shared/internal.msg.service';
import { StatusMessagesService } from '../shared/statusmessage.service';
import { IPaginatorChange } from '../model/interfaces';
import { PrepareListData } from '../shared/preplistdata';
import { Sort } from '../model/sort';

export interface Unit {
    number: string;
}

@Component({
    selector: 'cafs-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})


export class HomeComponent implements OnInit {
    loggedUser: User = User.getEmpty();
    messages: InfoMessageItem[] = [];

    levels = ['bg-danger', 'bg-warning', 'bg-success'];
    resultDate: Date = new Date();
    resultAssignmentNr: string = '';
    advancedSearchbarOpen: boolean = false;
    firstLoading: boolean = true;
    hideInactive: boolean = true;
    hideOtherDepts: boolean = false;
    noAssignmentsToShow: boolean = false;
    showLoading: boolean = false;
    showOnlyMyConsultants: boolean = false;
    showOnlyExpired: boolean = false;
    showOnlyEnded: boolean = false;
    showOnlyWithActiveConsultants: boolean = false;
    showOnlyWithoutConsultants: boolean = false;

    //--------Advanced Search strings-------
    assignEndDateSearch: string = '';
    assignNrSearch: string = '';
    assignStartDateSearch: string = '';
    consNameSearch: string = '';
    consNrSearch: string = '';
    consEndDateSearch: string = '';
    consStartDateSearch: string = '';
    deptSearch: string = '';
    extendDateSearch: string = '';
    managerSearch: string = '';
    reasonSearch: string = '';
    unitNrSearch: string = '';
    currentPage: number = 0;
    rowsPerPage: number = 10;
    sortField: string = "assignmentNumber";

    assignmentData: AssignmentData[] = [];
    slicedRows: AssignmentData[] = [];
    filteredRows: AssignmentData[] = [];
    searchString: string = '';
    totalPages: number = 0;
    expandedElement: Consultant[] = [];
    allRowsExpanded: boolean = false;
    selectedUnit: string = 'All';
    units: Unit[] = [];

    // for dialogs
    dlgType2: string = '';
    dlgType: string = '';
    dlgAssignmentNumber: string = '';
    dlgDepartment: string = '';
    dlgAssignmentManager: string = '';
    dlgAddedCommentsCount: number = 0;
    dlgHasDispensation: boolean = false;
    dlgIsDateSet: boolean = false;


    constructor(private userService: UserService,
        private assignmentApi: AssignmentService,
        private common: CommonService,
        private filterService: FilterService,
        private infoMessageService: InfoMessageService,
        private userInfoService: UserInfoService,
        private consultantService: ConsultantService,
        private msgService: InternalMsgService,
        private statusMessagesService: StatusMessagesService) {}

    ngOnInit() {
        this.showLoading = false;
        this.hideOtherDepts = false;
        this.showOnlyExpired = false;
        this.getUserInfo();
       /* this.msgService.loginCompleteSet$.subscribe(logincomplete => {
            console.log('logincomplete',logincomplete)
            if (logincomplete) {
                this.getUserInfo();
            }
        });*/
    }

    @HostListener( 'window:tdsSort', ['$event'] )
    handlePAginationEvent( event:any): void {
        const details = event['detail'];
        const sortObj: Sort = {
            active: details['columnKey'],
            direction: details['sortingDirection']
        }
        this.sort(sortObj);
    }

    @HostListener( 'document:keydown', ['$event'] )
    handleKeyboardEvent( event:KeyboardEvent ): boolean {
        return true;
        if (event.key == 'KeyDown') {

        }
        // const isHourField = this.hourFieldNames.findIndex( x => x == event.target['name'] ) != -1;
        // const isNumeric = this.numbers.findIndex( x => x == event.key.toLowerCase() ) != -1;
        // const value: string = event.target['value'];
        // const isvalidKey = this.allowedInputChars.findIndex( x => x == event.key.toLowerCase() ) != -1;

        // // if field other than hourXXXdat - allow any input
        // if (!isHourField) return true;

        // // if not an allowed key - abort
        // if (!isvalidKey) return false;

        // if (event.key == '-')
        // {
        //     if (event.target['value'].includes('-')) return false;
        //     if (event.target['selectionStart'] > 0) return false;
        //     return true;
        // }

        // // only one of , or . is allowed - abort
        // if ((value.includes('.') || value.includes(',')) && (event.key == ',' || event.key == '.') ) return false;

        // // If input is comma then replace with period - abort
        // if (event.key == ',')
        // {
        //     event.target['value'] = event.target['value'] + '.';
        //     return false;
        // }

        // if (event.target['selectionStart'] != event.target['selectionEnd']) return true;

        // // number cannot be bigger than 999 set to previous value - abort
        // if ( isNumeric && Number.parseFloat(value + event.key) > 999) {
        //     event.target['value'] = event.target['value']; ;
        //     return false;
        // }

        // // number cannot be smaller than -999 set to previous value - abort
        // if ( isNumeric && Number.parseFloat(value + event.key) < -999) {
        //     event.target['value'] = event.target['value']; ;
        //     return false;
        // }

        // // all checks passed
        // return true;
    }


    //-------------------------------------------------------------------------------------
    //-------------------------------------API METHODS-------------------------------------
    //-------------------------------------------------------------------------------------
    getUserInfo(): void {
        this.msgService.ontoggleSpinnerSet(true);

        this.showLoading = true;
        this.userInfoService.getUserInfo(this.userService.getUser().azureUserName)
            .subscribe( {
                next: (data: ReturnObject<User>) => {
                    if (data.isFailure) {
                        this.statusMessagesService.showToasterError('Error', data.failureMessage);
                        return;
                    }
                    var user = this.userService.getUser();
                    user.accessFeatures = data.value.accessFeatures;
                    user.department = data.value.department;
                    user.name = data.value.name;
                    user.role = data.value.role;
                    user.id = data.value.id;
                    user.azureUserName = data.value.azureUserName;
                    user.userKey = data.value.userKey;
                    user.actsAsOtherUser = data.value.actsAsOtherUser;
                    this.userService.setUser(user);
                    this.loggedUser = user;

                    this.getMessages();
                    this.loadAssignments();
                    this.getUnits();
                    this.openExpiredAssignmentsDialog();
                    },
                error: (err) => {
                    this.statusMessagesService.showHttpError(err);
                },
                complete: () => {
                    this.showLoading = false;
                    this.msgService.ontoggleSpinnerSet(false);
                }
            }
        );
    }

    getMessages(): void {
        this.msgService.ontoggleSpinnerSet(true);
        this.showLoading = true;
        this.infoMessageService.getMessages()
            .subscribe( {
                next: (data: ReturnObject<InfoMessageItem[]>) => {
                    if (data.isFailure) {
                        this.statusMessagesService.showToasterError('Error', data.failureMessage);
                        return;
                    }
                    this.messages = data.value;
                },
                error: (err) => {
                    this.statusMessagesService.showHttpError(err);
                },
                complete: () => {
                    this.msgService.ontoggleSpinnerSet(false);
                    this.showLoading = false;
                }
            }
        );
    }

    getUnits(): void {
        this.msgService.ontoggleSpinnerSet(true);
        this.showLoading = true;
        this.consultantService.GetUnitNumbers()
            .subscribe( {
                next: (data: ReturnObject<string[]>) => {
                    if (data.isFailure) {
                        this.statusMessagesService.showToasterError('Error', data.failureMessage);
                        return;
                    }
                    this.units.push({ number: 'All' });
                    data.value.forEach(x =>
                        this.units.push({ number: x })
                    )
                },
                error: (err) => {
                    this.statusMessagesService.showHttpError(err);
                },
                complete: () => {
                    this.msgService.ontoggleSpinnerSet(false);
                    this.showLoading = false;
                }
            }
        );
    }

    setAssignmentEndDate(assignNr: string, endDate: Date): void {
        this.msgService.ontoggleSpinnerSet(true);
        this.showLoading = true;
        this.assignmentApi.setAssignmentEndDate(new ChangeAssignmentDate(assignNr, endDate))
            .subscribe( {
                next: (data: ReturnObject<string>) => {
                    if (data.isFailure) {
                        this.showLoading = false;
                        this.statusMessagesService.showToasterError('Error', data.failureMessage);
                        return;
                    }

                    this.loadAssignments();
                    this.statusMessagesService.showToasterInfo('Saved', data.value);
                },
                error: (err) => {
                    this.statusMessagesService.showHttpError(err);
                },
                complete: () => {
                    this.msgService.ontoggleSpinnerSet(false);
                    this.showLoading = false;
                }
            }
        );
    }

    loadAssignments(): void {
        this.msgService.ontoggleSpinnerSet(true);
        this.showLoading = true;
        this.assignmentApi.getAssignments()
            .subscribe( {
                next: (data: ReturnObject<AssignmentData[]>) => {
                    if (data.isFailure) {
                        this.showLoading = false;
                        this.statusMessagesService.showToasterError('Error', 'Failed to load assignments');
                        return;
                    }

                    PrepareListData.prepareData(data.value, this.sortField).then(data => {
                        this.assignmentData = data ?? [];
                        this.filterTableData();
                    });
                },
                error: (err) => {
                    this.statusMessagesService.showHttpError(err);
                },
                complete: () => {
                    this.msgService.ontoggleSpinnerSet(false);
                    this.showLoading = false;
                }
            }
        );
    }

    getNumPages() {
        return Math.ceil( this.assignmentData.length / this.rowsPerPage);
    }

    setSlicedRows(): void {
        this.slicedRows = this.filteredRows.slice(this.currentPage * this.rowsPerPage, (this.currentPage * this.rowsPerPage) + this.rowsPerPage)
    }

    // -------------------------------------------------------------
    // Pagination
    // -------------------------------------------------------------
    pageChange($event: IPaginatorChange): void {
        this.currentPage = $event.currentPageNo;

        const newNumRows = (this.rowsPerPage * this.currentPage) + this.rowsPerPage > this.filteredRows.length
            ? (this.filteredRows.length % this.rowsPerPage)
            : this.rowsPerPage;

        const curStart = $event.currentPageNo * this.rowsPerPage;
        const curEnd = curStart + newNumRows;

        this.slicedRows = this.filteredRows.slice(curStart, curEnd);
    }

    pageSizeChange($event: number): void {
        this.rowsPerPage = $event;
        this.totalPages = Math.ceil( this.filteredRows.length / this.rowsPerPage );
        if (this.totalPages <= this.currentPage)
            this.currentPage = this.totalPages -1;
        if (this.totalPages >= 1 && this.currentPage == -1)
            this.currentPage = 0;
        this.setSlicedRows();
    }

    //-------------------------------------------------------------------------------------
    //-------------------------------------UNIT SEARCH-------------------------------------
    //-------------------------------------------------------------------------------------
    setUnitSearchValue(unit: string) {
        this.unitNrSearch = unit;
        this.filterTableData();
    }


    clearUnit() {
        this.unitNrSearch = '';
        this.filterTableData();
        this.selectedUnit = 'All';
    }


    //-------------------------------------------------------------------------------------
    //-------------------------------------BOOLS-------------------------------------------
    //-------------------------------------------------------------------------------------
    hasDispensation(assignmentData: AssignmentData): boolean {
        return assignmentData.dispensation.toLowerCase() === 'true';
    }

    canGiveDispensation(): boolean {
        return this.loggedUser.accessFeatures.includes('givedispensation');
    }

    isProduction(): boolean {
        return window.location.host.startsWith('cafs.scania.com');
    }

    IsNoAssignmentsToShowInUsersDept(): boolean {
        return this.noAssignmentsToShow
            && this.hideOtherDepts
            && this.common.isNullOrWhiteSpace(this.searchString)
            && !this.isAdvancedSearchActive()
            && !this.hideInactive
            && !this.showOnlyExpired
            && !this.showOnlyEnded
            && !this.showOnlyWithActiveConsultants
            && !this.showOnlyWithoutConsultants;
    }

    isAllowedToEditEndDate(assingmentManager: string): boolean {
        return this.loggedUser.accessFeatures.includes('setenddateall')
            || (this.loggedUser.accessFeatures.includes('setenddateown')
                && this.loggedUser.id == assingmentManager);
    }

    isAllowedToEditExtendDate(assingmentManager: string): boolean {
        return this.loggedUser.accessFeatures.includes('extendall')
            || (this.loggedUser.accessFeatures.includes('extendown')
                && this.loggedUser.id == assingmentManager);
    }

    isManager(): boolean {
        return this.loggedUser.role.toLowerCase() === 'chef' || this.loggedUser.role.toLowerCase() === 'chef tillförordnad'
    }

    isSysAdmin(): boolean {
        return this.loggedUser.accessFeatures.includes('sysadmin');
    }

    isEndDatePassed(endDate: Date): boolean {
        return this.isDateSet(endDate)
            && this.common.dateAsNumber(endDate) <= this.common.dateAsNumber(new Date());
    }

    hasExpired(daysLeft: number, endDate: Date): boolean {
        return daysLeft <= 0 && !this.isEndDatePassed(endDate);
    }

    containsExpiredAssignments(assignmentData: AssignmentData[]): boolean {
        let flag = false;

        assignmentData.forEach(x => {
            if (this.hasExpired(x.daysLeftToExtend, x.assignmentEndDate)
                && !this.isDateSet(x.assignmentEndDate))
                flag = true;
        });

        return flag;
    }

    isDateSet(date: Date): boolean {
        return !(this.common.dateAsNumber(date) == 20991231 || date == null);
    }

    containsEndedAssignWithActiveCons(assignmentData: AssignmentData[]): boolean {
        let flag = false;

        assignmentData.forEach(x => {
            if (this.isEndDatePassed(x.assignmentEndDate)
                && (x.assignedConsultants
                    .filter(c => this.isConsultantActive(c.consultantEnddate))).length > 0)
                flag = true;
        });

        return flag;
    }

    isAdvancedSearchActive(): boolean {
        return (!this.common.isNullOrWhiteSpace(this.consNameSearch)
            || !this.common.isNullOrWhiteSpace(this.consNrSearch)
            || !this.common.isNullOrWhiteSpace(this.assignNrSearch)
            || !this.common.isNullOrWhiteSpace(this.unitNrSearch)
            || !this.common.isNullOrWhiteSpace(this.deptSearch)
            || !this.common.isNullOrWhiteSpace(this.managerSearch)
            || !this.common.isNullOrWhiteSpace(this.assignStartDateSearch)
            || !this.common.isNullOrWhiteSpace(this.assignEndDateSearch)
            || !this.common.isNullOrWhiteSpace(this.extendDateSearch)
            || !this.common.isNullOrWhiteSpace(this.consStartDateSearch)
            || !this.common.isNullOrWhiteSpace(this.consEndDateSearch)
            || !this.common.isNullOrWhiteSpace(this.reasonSearch));
    }

    isConsultantActive(consultantEnddate: Date): boolean {
        return this.isDateSet(consultantEnddate)
            ? this.common.dateAsNumber(consultantEnddate) >= this.common.dateAsNumber(new Date())
            : true;
    }

    checkExpanded(element: any): boolean {
        let flag = false;

        this.expandedElement.forEach(x => {
            if (x === element) {
                flag = true;
            }
        });

        return flag;
    }


    //-------------------------------------------------------------------------------------
    //-------------------------------------VOIDS-------------------------------------------
    //-------------------------------------------------------------------------------------
    updateNrOfComments(assignmentNr: string = '', newComments: number): void {
        var assignment = this.assignmentData.find(x => x.assignmentNumber === assignmentNr);
        if (assignment) {
            assignment.nrOfComments += newComments;
        }
    }

    toggleAdvancedSearch(): void {
        this.advancedSearchbarOpen = !this.advancedSearchbarOpen;
    }

    onQuickFilterInput(event: Event): void {
        const hostValue = (event.target as { value?: string } | null)?.value;
        const inputValue = ((event as CustomEvent<InputEvent>).detail?.target as HTMLInputElement | null)?.value;

        this.searchString = hostValue ?? inputValue ?? '';
        this.filterTableData();
    }

    clearAdvancedSearchStrings(): void {
        this.consNameSearch = '';
        this.consNrSearch = '';
        this.consStartDateSearch = '';
        this.consEndDateSearch = '';
        this.reasonSearch = '';
        this.assignNrSearch = '';
        this.unitNrSearch = '';
        this.deptSearch = '';
        this.managerSearch = '';
        this.assignStartDateSearch = '';
        this.assignEndDateSearch = '';
        this.extendDateSearch = '';
        this.selectedUnit = 'All';
        this.filterTableData();
    }

    hideInactiveChecked(e: any): void {
        if (e.detail.checked) {
            this.hideInactive = true;
            this.filterTableData();
            return;
        }

        this.hideInactive = false;
        this.filterTableData();
    }

    showOnlyMyConsultantsChecked(e: any): void {
        if (e.detail.checked) {
            this.showOnlyMyConsultants = true;
            this.filterTableData();
            return;
        }

        this.showOnlyMyConsultants = false;
        this.filterTableData();
    }

    hideOtherDeptsChecked(e: any): void {
        if (e.detail.checked) {
            this.hideOtherDepts = true;
            this.filterTableData();
            return;
        }

        this.hideOtherDepts = false;
        this.filterTableData();
    }

    showOnlyEndedChecked(e: any): void {
        if (e.detail.checked) {
            this.showOnlyEnded = true;
            this.filterTableData();
            return;
        }

        this.showOnlyEnded = false;
        this.filterTableData();
    }

    showOnlyExpiredChecked(e: any): void {
        if (e.detail.checked) {
            this.showOnlyExpired = true;
            this.filterTableData();
            return;
        }

        this.showOnlyExpired = false;
        this.filterTableData();
    }

    showOnlyWithActiveConsultantsChecked(e: any): void {
        if (e.detail.checked) {
            this.showOnlyWithActiveConsultants = true;
            this.filterTableData();
            return;
        }

        this.showOnlyWithActiveConsultants = false;
        this.filterTableData();
    }

    showAdvancedSearch(e: any): void {
        this.advancedSearchbarOpen = e.detail.checked;
    }

    showOnlyWithoutConsultantsChecked(e: any): void {
        if (e.detail.checked) {
            this.showOnlyWithoutConsultants = true;
            this.filterTableData();
            return;
        }

        this.showOnlyWithoutConsultants = false;
        this.filterTableData();
    }

    async sort(sort: Sort) {
        if (this.filteredRows.length === 0) return;
        PrepareListData.sort(this.filteredRows, sort, this.sortField ).then( data => {
            this.filteredRows = data;
            this.setSlicedRows();
        });
    }

    filterTableData(): void {
        //------------------------------------------------------------------------------------------
        //---------------------------------------------CHECK BOXES-------------------------------------------------
        //------------------------------------------------------------------------------------------
        this.filteredRows = this.hideInactive
            ? this.assignmentData.filter(assignment => !this.isEndDatePassed(assignment.assignmentEndDate))
            : this.assignmentData;

        if (this.hideOtherDepts) {
            this.filteredRows = this.filteredRows
                .filter(x => this.common.isUsersdeptOrChildDept(this.loggedUser.department, x.department));
        }

        if (this.showOnlyMyConsultants) {
            this.filteredRows = this.filteredRows
                .filter(x => this.loggedUser.id == x.assignmentManager);
        }

        if (this.showOnlyExpired) {
            this.filteredRows = this.filteredRows
                .filter(x => this.hasExpired(x.daysLeftToExtend, x.assignmentEndDate)
                    && !this.isDateSet(x.assignmentEndDate));
        }

        if (this.showOnlyEnded) {
            this.filteredRows = this.filteredRows
                .filter(x => this.isEndDatePassed(x.assignmentEndDate));
        }

        if (this.showOnlyWithActiveConsultants) {
            this.filteredRows = this.filteredRows
                .filter(x => x.assignedConsultants
                    .filter(cons => this.isConsultantActive(cons.consultantEnddate)).length > 0)
        }

        if (this.showOnlyWithoutConsultants) {
            this.filteredRows = this.filteredRows
                .filter(x => x.assignedConsultants.length === 0
                    || (x.assignedConsultants
                        .filter(cons => this.isConsultantActive(cons.consultantEnddate)).length === 0))
        }

        //------------------------------------------------------------------------------------------
        //----------------------------------------SEARCH STRINGS------------------------------------
        //------------------------------------------------------------------------------------------
        if (!this.common.isNullOrWhiteSpace(this.consNameSearch))
            this.filteredRows = this.filterService
                .containsConsultantName(this.consNameSearch, this.filteredRows);

        if (!this.common.isNullOrWhiteSpace(this.consNrSearch))
            this.filteredRows = this.filterService
                .containsConsultantNumber(this.consNrSearch, this.filteredRows);

        if (!this.common.isNullOrWhiteSpace(this.consStartDateSearch))
            this.filteredRows = this.filterService
                .containsConsultantStartDate(this.consStartDateSearch, this.filteredRows);

        if (!this.common.isNullOrWhiteSpace(this.consEndDateSearch))
            this.filteredRows = this.filterService
                .containsConsultantEndDate(this.consEndDateSearch, this.filteredRows);

        if (!this.common.isNullOrWhiteSpace(this.reasonSearch))
            this.filteredRows = this.filterService
                .containsReason(this.reasonSearch, this.filteredRows);

        if (!this.common.isNullOrWhiteSpace(this.assignNrSearch))
            this.filteredRows = this.filterService
                .containsAssignmentNr(this.assignNrSearch, this.filteredRows);

        if (!this.common.isNullOrWhiteSpace(this.assignStartDateSearch))
            this.filteredRows = this.filterService
                .containsAssignmentStartDate(this.assignStartDateSearch, this.filteredRows);

        if (!this.common.isNullOrWhiteSpace(this.assignEndDateSearch))
            this.filteredRows = this.filterService
                .containsAssignmentEndDate(this.assignEndDateSearch, this.filteredRows);

        if (!this.common.isNullOrWhiteSpace(this.extendDateSearch))
            this.filteredRows = this.filterService
                .containsExtendDate(this.extendDateSearch, this.filteredRows);

        if (!this.common.isNullOrWhiteSpace(this.unitNrSearch))
            this.filteredRows = this.filterService
                .hasUnitNr(this.unitNrSearch, this.filteredRows);

        if (!this.common.isNullOrWhiteSpace(this.deptSearch))
            this.filteredRows = this.filterService
                .startsWithDepartment(this.deptSearch, this.filteredRows);

        if (!this.common.isNullOrWhiteSpace(this.managerSearch))
            this.filteredRows = this.filterService
                .containsManager(this.managerSearch, this.filteredRows);

        if (!this.common.isNullOrWhiteSpace(this.searchString))
            this.filteredRows = this.filterService
                .searchAll(this.searchString, this.filteredRows);
        this.totalPages = Math.ceil( this.filteredRows.length / this.rowsPerPage );

        if (this.totalPages <= this.currentPage)
            this.currentPage = this.totalPages -1;

        if (this.totalPages >= 1 && this.currentPage == -1)
            this.currentPage = 0;

        this.setSlicedRows();
    }

    expandAll(): void {
        this.allRowsExpanded = !this.allRowsExpanded;
        this.expandedElement = [];
    }

    closeInfoMessage(msg: InfoMessageItem): void {
        this.deleteElementFromArray(this.messages, msg);
    }

    deleteElementFromArray(array: any[], element: any): void {
        const INDEX = array.indexOf(element);
        array.splice(INDEX, 1);
    }

    pushPopElement(element: Consultant): void {
        const INDEX = this.expandedElement.indexOf(element);

        if (INDEX === -1) {
            this.expandedElement.push(element);
            return;
        }

        this.deleteElementFromArray(this.expandedElement, element);
    }


    //-------------------------------------------------------------------------------------
    //-------------------------------------NUMBERS-----------------------------------------
    //-------------------------------------------------------------------------------------
    calcDaysLeftFromToday(endDate: Date): number {
        let now = moment(new Date());
        let end = moment(endDate);
        let duration = moment.duration(end.diff(now));

        return Math.floor(duration.asDays()) + 1;
    }

    calcDaysLeftPercentage(daysLeft: number): number {
        return (daysLeft / 365) * 100;
    }

    daysOverdue(days: number): number {
        return this.minusToPlusNumber(days);
    }

    minusToPlusNumber(number: number): number {
        return number < 0
            ? number * -1
            : number;
    }


    //-------------------------------------------------------------------------------------
    //-------------------------------------STRINGS-----------------------------------------
    //-------------------------------------------------------------------------------------
    getBarColor(assignment: AssignmentData): string {
        const PERCENTAGE = this.calcDaysLeftPercentage(assignment.daysLeftToExtend);

        if (PERCENTAGE >= 75
            && !this.isDateSet(assignment.assignmentEndDate)) {

            return 'var(--tds-green-300';
        }

        if (PERCENTAGE < 75
            && PERCENTAGE >= 50
            && !this.isDateSet(assignment.assignmentEndDate)) {

            return 'var(--tds-green-100';
        }

        if (PERCENTAGE < 50
            && PERCENTAGE >= 25
            && !this.isDateSet(assignment.assignmentEndDate)) {

            return 'var(--tds-orange-300';
        }

        if ((PERCENTAGE <= 0 && !this.isDateSet(assignment.assignmentEndDate))
            || this.isEndDatePassed(assignment.assignmentEndDate)) {

            return 'var(--tds-grey-200';
        }

        if (this.isDateSet(assignment.assignmentEndDate)
            && !this.isEndDatePassed(assignment.assignmentEndDate)) {
            return 'var(--tds-blue-100';
        }

        return  'var(--tds-red-400';
    }

    getBarWidth(assignment: AssignmentData): string {
        const PERCENTAGE = this.calcDaysLeftPercentage(assignment.daysLeftToExtend);

        return PERCENTAGE <= 0
            || PERCENTAGE > 100
            || this.isDateSet(assignment.assignmentEndDate)
            ? '100%'
            : String(PERCENTAGE) + '%';
    }

    getConsultantInfoMsg(consultant: Consultant): string {
        return this.isConsultantActive(consultant.consultantEnddate)
            ? 'The consultant is active on this assignment'
            : 'End date has passed for this consultant';
    }

    getConsultantIconColor(consultant: Consultant): string {
        return this.isConsultantActive(consultant.consultantEnddate)
            ? 'color:var(--tds-green-500)'
            : 'color:var(--tds-red-600)';
    }

    getConsultantBorderColor(consultant: Consultant): string {
        return this.isConsultantActive(consultant.consultantEnddate)
            ? '2px solid green'
            : '2px solid red';
    }

    getPersonTooltip(consultants: Consultant[]): string {
        if (consultants.length === 0)
            return "No consultant is associated with this assignment.";

        let activeConsultants: number = 0;
        let inactiveConsultants: number = 0;
        let activeConsultantsString: string = "consultant(s) is currently active on this assignment"
        let inActiveConsultantsString: string = "consultant(s) with passed end date has previously been active on this assignment"


        consultants.forEach(x => {
            if (this.isConsultantActive(x.consultantEnddate))
                activeConsultants += 1;

            if (!this.isConsultantActive(x.consultantEnddate))
                inactiveConsultants += 1;
        });

        if (activeConsultants > 0
            && inactiveConsultants === 0)
            return `${activeConsultants} ${activeConsultantsString}.`;


        if (inactiveConsultants > 0
            && activeConsultants === 0)
            return `${inactiveConsultants} ${inActiveConsultantsString}.`;

        if (activeConsultants > 0
            && inactiveConsultants > 0)
            return `${activeConsultants} ${activeConsultantsString}, and ${inactiveConsultants} ${inActiveConsultantsString}.`;

        return "No consultant is associated with this assignment.";
    }

    hideMessage(msgId: number): void {
        this.messages = this.messages.filter( x => x.id != msgId);
    }

    //-------------------------------------------------------------------------------------
    //-------------------------------------ARRAYS------------------------------------------
    //-------------------------------------------------------------------------------------
    orderConsultantsByActiveStatus(consultants: Consultant[]): Consultant[] {
        let newArray: Consultant[] = [];

        consultants.forEach(x => {
            if (this.isConsultantActive(x.consultantEnddate)) {
                newArray.push(x);
            }
        });

        consultants.forEach(x => {
            if (!this.isConsultantActive(x.consultantEnddate)) {
                newArray.push(x);
            }
        });

        return newArray;
    }

    getConsultantsOtherAssignments(consultant: Consultant): Consultant[] {
        let recordsOfConsultant: Consultant[] = [];

        this.assignmentData.forEach(x => {
            x.assignedConsultants.forEach(cons => {
                if ((cons.consultantNumber == consultant.consultantNumber)
                    && (cons.assignmentNumber != consultant.assignmentNumber))
                    recordsOfConsultant.push(cons);
            })
        });

        return recordsOfConsultant;
    }


    //-------------------------------------------------------------------------------------
    //-------------------------------------DIALOGS-----------------------------------------
    //-------------------------------------------------------------------------------------
    openExpiredAssignmentsDialog() {
        this.dlgType = 'expiredassignmentdlg';

        this.firstLoading = false;
    }

    openActiveConsOnInactiveAssignDialog() {
        this.dlgType2 = 'activeconsoninactivedlg';
    }

    openSysadminDialog() {
        this.dlgType = 'sysadmindlg';
    }

    openDispensationDialog(_assignmentNumber: string, _hasDispensation: boolean) {
        this.dlgHasDispensation = _hasDispensation;
        this.dlgAssignmentNumber = _assignmentNumber;
        this.dlgType = 'dispensationdlg';
    }

    openCommentDialog(_assignmentNumber: string, _department: string, _assignmentManager: string) {
        this.dlgAssignmentNumber = _assignmentNumber;
        this.dlgDepartment = _department;
        this.dlgAssignmentManager = _assignmentManager;
        this.dlgAddedCommentsCount = 0;
        this.dlgType = 'commentdlg';
    }

    openExtendDateDialog(_assignmentNumber: string, _department: string, _assignmentManager: string, _isDateSet: boolean): void {
        this.dlgAssignmentNumber = _assignmentNumber;
        this.dlgDepartment = _department;
        this.dlgAssignmentManager = _assignmentManager;
        this.dlgIsDateSet = _isDateSet;
        this.dlgType = 'extenddatedlg';
    }

    openEndDateDialog(_assignmentNumber: string, _department: string, _assignmentManager: string, _isDateSet: boolean): void {
        this.dlgAssignmentNumber = _assignmentNumber;
        this.dlgDepartment = _department;
        this.dlgAssignmentManager = _assignmentManager;
        this.dlgIsDateSet = _isDateSet;
        this.dlgType = 'enddatedlg';
    }

    onCloseDlg($event: any) {
        if (this.dlgType == 'commentdlg') {
            if ($event !== 0) {
                this.updateNrOfComments(this.dlgAssignmentNumber, $event)
            }
        }

        if (this.dlgType == 'extenddatedlg' && $event === true) {
            this.loadAssignments();
        }

        if (this.dlgType == 'dispensationdlg' && $event === true) {
            this.loadAssignments();
        }

        if (this.dlgType == 'sysadmindlg') {
            this.loadAssignments();
        }

        if (this.dlgType == 'enddatedlg' && $event === true) {
            this.loadAssignments();
        }

        if (this.dlgType == 'expiredassignmentdlg') {
            this.dlgType = ''
            if (this.containsEndedAssignWithActiveCons(this.assignmentData)) {
                this.openActiveConsOnInactiveAssignDialog();
            }
        }

        if (this.dlgType == 'activeconsoninactivedlg') {
            this.dlgType2 = ''
        }

        this.dlgType = ''
    }
}
